export default "__VITE_ASSET__ur8xfiAM__"